import { render } from "./SelectCouponModal.vue?vue&type=template&id=5ebecc44&ts=true"
import script from "./SelectCouponModal.vue?vue&type=script&lang=ts"
export * from "./SelectCouponModal.vue?vue&type=script&lang=ts"

import "./SelectCouponModal.vue?vue&type=style&index=0&id=5ebecc44&lang=postcss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__